<template>
	<div
		class="alarm-input"
		@keydown.enter="emit"
	>
		<BaseTextInput
			v-model="description"
			class="description"
		/>
		<TimeSpecifier
			:value="time"
			class="time"
			@input="time = $event"
		/>
		<BaseButton
			class="submit"
			@click="emit"
		>
			Add
		</BaseButton>
	</div>
</template>

<script>
import * as R from 'ramda';
import uniqid from 'uniqid';
import BaseTextInput from './BaseTextInput.vue';
import TimeSpecifier from './TimeSpecifier.vue';
import BaseButton from './BaseButton.vue';

export default {
	name: 'AlarmInput',
	components: {
		BaseButton,
		BaseTextInput,
		TimeSpecifier,
	},
	data() {
		return {
			id: uniqid(),
			description: '',
			time: 0,
		};
	},
	methods: {
		emit() {
			this.$emit('new', {
				id: R.clone(this.id),
				description: R.clone(this.description),
				time: R.clone(this.time),
				timeLeft: R.clone(this.time),
			});
			this.id = uniqid();
			this.description = '';
			this.time = 0;
		},
	},
};
</script>

<style lang="stylus" scoped>
.alarm-input
	display grid
	grid-auto-rows auto
	grid-auto-columns auto
	grid-template-columns 3fr 1fr 5rem
	grid-column-gap .5rem
	grid-template-areas "description time submit"
	align-items center
	justify-content center
	grid-rows auto
	height 2rem
	width 100%

	&,
	& *
		box-sizing border-box

	> .description
		grid-area description
		place-self stretch stretch
		display block
		width 100%
		height 100%

		&::before
			content 'Description: '
			display inline

	> .time
		grid-area time
		place-self stretch stretch

		&::before
			content 'Time: '
			display inline

	> .submit
		grid-area submit

	@media (max-width: 1400px)
		grid-template-columns 2fr 1fr 5rem

	@media (max-width: 1100px)
		grid-template-columns 1fr 1fr 5rem

	@media (max-width: 800px)
		grid-template-areas\
			"description"\
			"time"\
			"submit"
		grid-template-columns 100%
		grid-row-gap .25rem
		padding 0 1rem
</style>



// WEBPACK FOOTER //
// src/components/AlarmInput.vue